export const lightTheme = {
    body: "#FCF6F4",
    text: "#000000",
    fontFamily: "system-ui",
    bodyRgba: "252,246,244",
    textRgba: "0,0,0"
}

export const DarkTheme = {
    body: "#171717",
    text: "#FCF6F4",
    fontFamily: "system-ui",
    textRgba: "252,246,244",
    bodyRgba: "0,0,0",
}